import { get } from 'lodash';

export class AgentPersonalDetailRequest {
  public agentCode: string;
  public clientNo: string;
  public loggedInUserId: number;
  public loginUser: string;
  public requesterClientNumber: string;
  public sourceSystem: string;
  public promoCode: string;
  constructor(initial: any) {
    this.agentCode = get(initial, 'agentCode', '');
    this.promoCode = get(initial, 'promoCode', '');
    this.clientNo = get(initial, 'clientNo', '');
    this.loggedInUserId = get(initial, 'loggedInUserId', 0);
    this.loginUser = get(initial, 'loginUser', '');
    this.requesterClientNumber = get(initial, 'requesterClientNumber', '');
    this.sourceSystem = get(initial, 'sourceSystem', 'MLTC')
  }
}

export class AgentPersonalDetailResponse {
  public clientNum?: string;
  public clientType?: string;
  public surname?: string;
  public givname?: string;
  public salutation?: string;
  public fullName?: string;
  public nric?: string;
  public dob?: string;
  public gender?: string;
  public maritalStatus?: string;
  public nationality?: string;
  public race?: string;
  public homeNum?: string;
  public mobileNum?: string;
  public officeNum?: string;
  public faxNum?: string;
  public emailId?: string;
  public residential_Addr_1?: string;
  public residential_Addr_2?: string;
  public residential_Addr_3?: string;
  public residential_Addr_4?: string;
  public residential_Addr_5?: string;
  public residentialAddrCountry?: string;
  public residentialAddrPostalCode?: string;
  public agentTerminatedFlag?: string;
  constructor(initial: any) {
    Object.assign(this, initial);
  }
}